/**
 * Topic and publication date row for BlogWriter generation config.
 * Phase 5 extraction (05-03).
 */
export default function TopicAndDateRow({
    articleTopic,
    setArticleTopic,
    articleDate,
    setArticleDate,
}) {
    return (
        <>
            <div className="promo-input">
                <label>
                    <span className="prompt-label">Article Topic (optional)</span>
                    <span className="prompt-hint">Describe the main theme for topic-focused news research.</span>
                </label>
                <textarea
                    value={articleTopic}
                    onChange={(e) => setArticleTopic(e.target.value.slice(0, 4000))}
                    placeholder="Example: Gold market outlook and central-bank reserve flows"
                    rows={5}
                />
            </div>
            <div className="promo-input setting-item">
                <label>
                    <span className="prompt-label">Publication date (optional)</span>
                    <span className="prompt-hint">Date used in the first block; leave empty for today.</span>
                </label>
                <input
                    type="date"
                    className="bw-input"
                    value={articleDate || ''}
                    onChange={(e) => setArticleDate(e.target.value || null)}
                />
            </div>
        </>
    );
}
